var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sweet-bar"},_vm._l((_vm.sweetness),function(item,index){return _c('li',{key:index,staticClass:"sweet-list",on:{"click":function($event){return _vm.setSweetness(item)}}},[_c('p',{class:{ active: item.Name === _vm.activeSweet }},[_vm._v(" "+_vm._s(item.Name)+"% ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }